import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconHome: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.4445 10.0987H8.55559V15.6998H5.4445V10.0987Z" />
      <path d="M13.5489 7.04201L7.55226 0.736688C7.24977 0.422925 6.75732 0.420848 6.45233 0.732049C6.45083 0.733589 6.44932 0.735136 6.44782 0.736688L0.451198 7.05002C0.158098 7.35399 -0.00438002 7.76612 8.98442e-05 8.19426V14.8997C-0.00115449 15.7502 0.644571 16.4532 1.4701 16.5H3.88895V9.29849C3.88895 8.85657 4.23717 8.49832 4.66673 8.49832H9.33336C9.76291 8.49832 10.1111 8.85657 10.1111 9.29849V16.5H12.53C13.3555 16.4532 14.0013 15.7502 14 14.8997V8.19425C14.0006 7.76451 13.8389 7.35134 13.5489 7.04201Z" />
    </svg>
  </IconStyled>
);

IconHome.defaultProps = iconDefaultProps;
IconHome.displayName = 'IconHome';

export default IconHome;
